<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row" v-if="authUser.permissions.product_summary_cost_view_cost">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Cost</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalCost | currency }}
                <!-- | {{ totalCogsSaldo | currency }} | {{ cogsSaldo.length }} -->
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Journal</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalJournal | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row" v-if="authUser.permissions.product_summary_cost_view_cost">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Barang Dagangan</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalCostBarangDagangan | currency }}
                <!-- | {{  totalCogsSaldoBarangDagangan | currency }} -->
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Bahan Baku</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalCostBahanBaku | currency }}
                <!-- | {{ totalCogsSaldoBarangBaku | currency }} -->
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Bahan Jadi</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalCostBarangJadi | currency }}
                <!-- | {{ totalCogsSaldoBarangJadi | currency }} -->
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Bahan Setengah Jadi</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalCostBarangSetengahJadi | currency }}
                <!-- | {{ totalCogsSaldoBarangSetengahJadi | currency }} -->
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row" v-if="authUser.permissions.product_summary_cost_view_cost">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Journal Barang Dagangan</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalJournalBarangDagangan | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Journal Bahan Baku</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalJournalBahanBaku | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Journal Bahan Jadi</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalJournalBarangJadi | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Journal Bahan Setengah Jadi</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalJournalBarangSetengahJadi | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Product Summary by Cost</h5>
            </div>
            <div class="card-body">
              <ul class="nav nav-tabs nav-bordered">
                <li class="nav-item"><a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">Sales</a></li>
                <!-- <li class="nav-item"><a href="#process" data-toggle="tab" aria-expanded="false" class="nav-link">Process</a></li>
                <li class="nav-item"><a href="#barang-dagangan" data-toggle="tab" aria-expanded="false" class="nav-link">Barang Dagangan</a></li> -->
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="general">
                  <div class="table-responsive">
                    <div class="form-inline ml-auto">
                      {{ processDate }}
                      <div class="button-group">
                        <button class="btn btn-sm btn-soft-primary dropdown-toggle" type="button" id="list-action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                        <div class="dropdown-menu" aria-labelledby="list-action">
                          <a class="dropdown-item" href="javascript:void(0)" @click="exportExcel">Export Excel</a>
                          <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalSummaryCost" data-backdrop="static" data-keyboard="false" @click="setProcessInventory">Process Inventory Begin</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="refreshJournal">Get Journal</a>
                        </div>
                      </div>
                      <div class="button-group">
                        <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                          <i class="fa fa-filter" aria-hidden="true"></i>
                            Filter
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu p-2">
                          <span>Etc:</span>
                          <div class="dropdown-divider"></div>
                          <li>
                            <a href="javascript:void(0)" class="small" tabIndex="-1">
                              <input type="checkbox" :value="true" v-model="filterTotalJournal"/>&nbsp; Diff Total Journal
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="small" tabIndex="-1">
                              <input type="checkbox" :value="true" v-model="filterTotalJournalSelisih"/>&nbsp; Selisih Total Journal (>100)
                            </a>
                          </li>
                          <span>Type</span>
                          <div class="dropdown-divider"></div>
                          <li><a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" value="Barang Dagangan" v-model="filterType"/>&nbsp; Barang Dagangan
                          </a></li>
                          <li><a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" value="Bahan Baku" v-model="filterType"/>&nbsp; Bahan Baku
                          </a></li>
                          <li><a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" value="Bahan Jadi" v-model="filterType"/>&nbsp; Bahan Jadi
                          </a></li>
                          <li><a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" value="Bahan Setengah Jadi" v-model="filterType"/>&nbsp; Bahan Setengah Jadi
                          </a></li>
                          <span>Category:</span>
                          <div class="dropdown-divider"></div>
                          <li v-for="ct in categoryList" :key="ct.id">
                            <a href="javascript:void(0)" class="small" tabIndex="-1">
                              <input type="checkbox" :value="ct.id" v-model="filterCategory"/>&nbsp; {{ ct.name }}
                            </a>
                          </li>
                        </ul>
                        <select class="btn btn-soft-outline-primary btn-sm ml-2" v-model="warehouse">
                          <option value="">-- All --</option>
                          <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                        </select>&nbsp;
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect ml-1" @click="refreshProduct">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="ml-1">Total rows: <b>{{ rowsTotal }}</b></span>
                      </div>
                      <div class="form-group mx-sm-3 mb-2">
                          <input type="search" placeholder="search... (min 3 chars)" class="form-control mr-1 input-search" v-model="searchQuery" @input="debounceSearch">
                      </div>
                      <span class="mr-1">
                        page:
                        <select v-model="currentPage">
                          <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                        </select>
                        / {{ pageLength }}
                      </span>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <table class="table table-item mb-0 table-sm table-hover"  v-if="authUser.permissions.product_summary_cost_view_cost">
                        <thead>
                            <tr>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                  {{ t.name }}
                                  <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="5" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="(u, index) in filterData" :key="u.id" style="cursor: pointer">
                            <td><b>{{ u.product_no }}</b></td>
                            <td>{{ u.product_name }}</td>
                            <td>
                              {{ u.type }}
                              {{ u.account_code }}
                            </td>
                            <td>{{ u.qty | currency }}</td>
                            <td>{{ u.uom_id }}</td>
                            <td>
                              <span v-for="a in u.amount" :key="a.id">
                                <span class="mr-2">[{{ a.queue }}] <b><i>{{ a.cost_qty }} {{ a.uom_id}}</i></b> <span v-if="authUser.permissions.product_summary_cost_view_cost">{{ a.cost | currency }}</span></span>
                                <span v-if="a.status === 'purchasing'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showPurchasingNo(a.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-success">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'retur sales'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showReturSales(a.ref_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-primary">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'inventory'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-warning">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'adjust'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-info">{{ a.status }}</span>
                                </span>
                                <span v-else>
                                  <span class="text-ref-sales">{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-info">{{ a.status }}</span>
                                </span>
                                <br>
                              </span>
                            </td>
                            <td class="text-right">{{ u.total | currency }}</td>
                            <td class="text-right">
                              <span v-if="u.total_journal === null">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              </span>
                              <span v-else>
                                <span v-if="u.total !== u.total_journal">{{ u.total_journal | currency }}</span>
                                <span v-else>{{ u.total_journal | currency }}</span>
                              </span>
                            </td>
                            <td>{{ u.total_diff | currency }}</td>
                            <td>
                              <button type="button" class="btn btn-sm btn-hard-primary" @click="getJournal(index)"><i class="fa fa-refresh"></i></button>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                    <table class="table table-item mb-0 table-sm table-hover"  v-else>
                        <thead>
                            <tr>
                                <th  v-for="t in title2" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="5" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="u in filterData" :key="u.id" style="cursor: pointer">
                            <td><b>{{ u.product_no }}</b></td>
                            <td>{{ u.product_name }}</td>
                            <td>{{ u.qty | currency }}</td>
                            <td>{{ u.uom_id }}</td>
                            <!-- <td>
                              <span v-for="a in u.amount" :key="a.id">
                                <span class="mr-2">[{{ a.queue }}] <b><i>{{ a.cost_qty }} {{ a.uom_id}}</i></b></span>
                                <span v-if="a.status === 'purchasing'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showPurchasingNo(a.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-success">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'retur sales'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost"  @click="showReturSales(a.ref_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-primary">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'inventory'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-warning">{{ a.status }}</span>
                                </span>
                                <span v-else-if="a.status === 'adjust'">
                                  <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                  <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-info">{{ a.status }}</span>
                                </span>
                                <span v-else>
                                  <span class="text-ref-sales">{{ a.ref_no }}</span>
                                  <span class="ml-1 badge badge-info">{{ a.status }}</span>
                                </span>
                                <br>
                              </span>
                            </td> -->
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="process">
                  <div class="table-responsive">
                    <h5>Barang Dagangan: {{ cogsSaldo.length }}</h5>
                    <table class="table table-item mb-0 table-sm table-hover">
                      <thead>
                        <th>Product</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                        <th>Condition</th>
                      </thead>
                      <tbody>
                        <tr v-for="(c , cidx) in cogsSaldo" :key="cidx">
                          <td>{{ c.product_no }}</td>
                          <td>{{ c.type }}</td>
                          <td>{{ c.qty }}</td>
                          <td>{{ c.cost | currency }}</td>
                          <td>{{ c.qty * c.cost | currency}}</td>
                          <td>{{ c.condition }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="barang-dagangan">
                  <table class="table table-item mb-0 table-sm table-hover">
                      <thead>
                        <th>Product</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Uom</th>
                        <th>Amount</th>
                        <th>Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, id) in costBarangDagangan" :key="id">
                          <td><b>{{ u.product_no }}</b></td>
                          <td>{{ u.product_name }}</td>
                          <td>
                            {{ u.type }}
                            {{ u.account_code }}
                          </td>
                          <td>{{ u.qty | currency }}</td>
                          <td>{{ u.uom_id }}</td>
                          <td>
                            <span v-for="a in u.amount" :key="a.id">
                              <span class="mr-2">[{{ a.queue }}] <b><i>{{ a.cost_qty }} {{ a.uom_id}}</i></b> <span v-if="authUser.permissions.product_summary_cost_view_cost">{{ a.cost | currency }}</span></span>
                              <span v-if="a.status === 'purchasing'">
                                <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showPurchasingNo(a.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                <span class="ml-1 badge badge-success">{{ a.status }}</span>
                              </span>
                              <span v-else-if="a.status === 'retur sales'">
                                <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showReturSales(a.ref_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                <span class="ml-1 badge badge-primary">{{ a.status }}</span>
                              </span>
                              <span v-else-if="a.status === 'inventory'">
                                <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                <span class="ml-1 badge badge-warning">{{ a.status }}</span>
                              </span>
                              <span v-else-if="a.status === 'adjust'">
                                <span class="text-ref-sales" v-if="authUser.permissions.product_summary_cost_view_cost" @click="showInventoryNo(a.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</span>
                                <span class="text-ref-sales" v-else>{{ a.ref_no }}</span>
                                <span class="ml-1 badge badge-info">{{ a.status }}</span>
                              </span>
                              <span v-else>
                                <span class="text-ref-sales">{{ a.ref_no }}</span>
                                <span class="ml-1 badge badge-info">{{ a.status }}</span>
                              </span>
                              <br>
                            </span>
                          </td>
                          <td class="text-right">{{ u.total | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>
      </div>
      <ProductCostListModal @getSyncData="getSyncCOGSData"/>
      <PurchasingModal />
      <InventoryFormModal />
      <ReturnModal />
      <ProductSummaryCostModal :processDate="processDate" @processInventory="processInventory" />
    </div>
    <!-- <div class="row">
      <div class="col-md-6">
        <pre>{{ dataRaw }}</pre>
      </div>
      <div class="col-md-6">
        <pre>{{ cogsSaldo }}</pre>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { inventoryUrl, financeUrl, product2Url, productUrl, setQtyTotalUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import InventoryFormModal from '@/components/inventory/InventoryFormModal.vue'
import ReturnModal from '@/components/return/ReturnModal.vue'
import DatePicker from 'vue2-datepicker'
import ProductSummaryCostModal from '@/components/product/ProductSummaryCostModal.vue'

export default {
  name: 'ProductSummaryCostList',
  props: ['scroll'],
  components: {
    Loading,
    ProductCostListModal,
    PurchasingModal,
    InventoryFormModal,
    ReturnModal,
    ProductSummaryCostModal,
    DatePicker
  },
  data () {
    var date = new Date().toISOString()
    var dateNow = new Date()
    const date1 = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())
    const date2 = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())
    return {
      processDate: null,
      filterType: [],
      filterTotalJournal: false,
      filterTotalJournalSelisih: false,
      startDate: [date1, date2],
      branch: '001',
      warehouse: '',
      uomList: [],
      checkAvailable: true,
      filterDate: date,
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      data: {},
      searchQuery: '',
      searchDebounce: null,
      ascending: false,
      sortClick: false,
      sortColumn: null,
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Name',
        prop: 'product_name',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty',
        align: 'text-left'
      }, {
        name: 'UoM',
        prop: 'uom_id',
        align: 'text-left'
      }, {
        name: 'Amount',
        prop: 'amount',
        align: 'text-left'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Total Journal',
        prop: 'total_journal',
        align: 'text-right'
      }, {
        name: 'Diff',
        prop: 'total_diff',
        align: 'text-right'
      }],
      title2: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Qty',
        prop: 'qty'
      }, {
        name: 'UoM',
        prop: 'uom_id'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    // this.setWh()
    // this.refreshProduct()
  },
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      warehouseList: state => state.warehouses.warehouseList,
      rowsTable: state => state.data.rowsTable,
      categoryList: state => state.products.productCategoryList,
      typeList: state => state.products.productTypeList,
      authUser: state => state.users.authUser
    }),
    cogsSaldo () {
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].qty) > 0) {
          const amount = array[i].amount
          let checkQty = false
          let amountUomID = null
          for (let a = 0; a < amount.length; a++) {
            amountUomID = amount[a].uom_id
            if (parseFloat(amount[a].cost_qty) < 0) {
              checkQty = true
            } else {
              if (checkQty) {
                break
              } else {
                const condition = parseFloat(amount[a].cost_qty) <= 0 ? 'null' : 'pass'
                const obj = {
                  cost: amount[a].cost,
                  qty: amount[a].cost_qty,
                  uom_id: amount[a].uom_id,
                  product_no: array[i].product_no,
                  type: array[i].type,
                  condition: condition
                }
                loop.push(obj)
              }
            }
          }
          if (checkQty) {
            const costAVG = parseFloat(array[i].total) / parseFloat(array[i].qty)
            const obj = {
              cost: costAVG,
              qty: array[i].qty,
              uom_id: amountUomID,
              product_no: array[i].product_no,
              type: array[i].type,
              condition: 'pass'
            }
            loop.push(obj)
          }
        }
      }
      return loop
    },
    cogsSaldoBarangDagangan () {
      const array = this.cogsSaldo.filter(d => d.type === 'Barang Dagangan')
      const loop = []
      for (let i = 0; i < array.length; i++) {
        loop.push(array[i])
      }
      return loop
    },
    totalCogsSaldoBarangDagangan () {
      const array = this.cogsSaldo.filter(d => d.type === 'Barang Dagangan')
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost)
      }
      return sum
    },
    totalCogsSaldoBarangBaku () {
      const array = this.cogsSaldo.filter(d => d.type === 'Bahan Baku Fiberglass' || d.type === 'Bahan Baku Pintu')
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost)
      }
      return sum
    },
    totalCogsSaldoBarangJadi () {
      const array = this.cogsSaldo.filter(d => d.type === 'Barang Jadi Pintu' || d.type === 'Barang Jadi Fiberglass')
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost)
      }
      return sum
    },
    totalCogsSaldoBarangSetengahJadi () {
      const array = this.cogsSaldo.filter(d => d.type === 'Barang Setengah Jadi Pintu')
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost)
      }
      return sum
    },
    totalCogsSaldo () {
      const array = this.cogsSaldo
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost)
      }
      return sum
    },
    totalJournal () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    totalCostBahanBaku () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 1 || d.type_id === 2)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournalBahanBaku () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 1 || d.type_id === 2)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    totalCostBarangJadi () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 3 || d.type_id === 4)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournalBarangJadi () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 3 || d.type_id === 4)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    costBarangDagangan () {
      const loop = []
      var array = this.dataRaw.filter(d => d.type === 'Barang Dagangan')
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].qty)) {
          loop.push(array[i])
        }
      }
      return loop
    },
    totalCostBarangDagangan () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 5)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournalBarangDagangan () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 5)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    totalCostBarangSetengahJadi () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 6)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournalBarangSetengahJadi () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type_id === 6)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    totalCost () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        // Minimum 3 characters for search
        if (this.searchQuery.length < 3) {
          return d
        }
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterTotalJournal === true) {
          if (parseFloat(d.total) !== parseFloat(d.total_journal)) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterTotalJournalSelisih === true) {
          var selisih = parseFloat(d.total) - parseFloat(d.total_journal)
          if (Math.abs(selisih) >= 100) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    debounceSearch () {
      clearTimeout(this.searchDebounce)
      // Minimum 3 characters for search
      if (this.searchQuery.length > 0 && this.searchQuery.length < 3) {
        return
      }
      this.searchDebounce = setTimeout(() => {
        // Search is client-side, just trigger reactivity
        this.$forceUpdate()
      }, 300)
    },
    async setProcessInventory () {
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const today = new Date(end)
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      this.processDate = new Date(tomorrow).toISOString()
    },
    async checkCogsSaldoNotNull () {
      const array = this.cogsSaldo
      const loop = []
      let obj = {
        error: false,
        data: []
      }
      for (let i = 0; i < array.length; i++) {
        const qty = parseFloat(array[i].qty)
        if (qty < 0) {
          loop.push(array[i].product_no)
        }
      }
      if (loop.length > 0) {
        obj = {
          error: true,
          data: loop
        }
        return obj
      }
    },
    async processInventory (value) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var detail = []
      var array = this.cogsSaldo
      const warehouse = this.warehouseList.find(d => d.company_no === value.company_no)
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          if (array[i].condition === 'pass') {
            const obj = {
              inventory_no: null,
              qty_demand: null,
              qty_done: array[i].qty,
              serial_number: null,
              product_no: array[i].product_no,
              product_sku: null,
              warehouse_no: warehouse ? warehouse.warehouse_no : null,
              uom_id: array[i].uom_id,
              inventory_date: value.process_date,
              branch_no: null,
              expired_date: null,
              sec_serial_number: null,
              internal_no: null,
              company_no: value.company_no,
              cost: array[i].cost,
              vendor_no: null,
              receive_finish: false,
              adjust_type: null
            }
            detail.push(obj)
          }
        }
      }
      var inv = {
        inventory_date: value.process_date,
        notes: null,
        purchasing_no: null,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        type_id: 'begin',
        company_no: value.company_no,
        ext_no2: null,
        vendor_no: null,
        details: detail
      }
      console.log(inv)
      await axios.post(inventoryUrl, inv, { headers: getHeader(), timeout: 600000 })
        .then(response => {
          console.log(response.data.message)
          console.log(response.data.data)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getJournal (index) {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var row = this.filterData[index]
      console.log('getJournal')
      console.log(row)
      var obj = {
        account: row.account_code,
        begin: begin,
        end: end,
        company_no: null,
        product_no: row.product_no,
        term: 'non-saldo'
      }
      console.log(obj)
      console.log(financeUrl + '/buku-besar-persediaan')
      await axios.post(financeUrl + '/buku-besar-persediaan', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          row.total_journal = response.data.saldoAkhirRaw
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    showReturSales (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    showInventoryNo (no) {
      var payload = {
        inventory_no: no
      }
      this.$store.commit('SET_INVENTORY_BY_NO', payload)
      this.$store.dispatch('getInventoryByNo', payload)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    async getSyncCOGSData (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var date = new Date(value.date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var array = this.selected
      var resp = {
        error: false,
        message: null,
        data: []
      }
      for (let i = 0; i < array.length; i++) {
        var data = this.dataRaw.find(d => d.id === array[i])
        var obj = {
          date: newDate,
          product_no: data.product_no,
          type: 'all',
          company_no: value.company_no
        }
        console.log(obj)
        await axios.post(productUrl + '/cost/sync', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.message = response.data.message
            resp.error = false
            var objresp = {
              product_no: obj.product_no
            }
            resp.data.push(objresp)
          })
          .catch(error => {
            console.log(error.response)
            this.$Progress.finish()
            this.loader.isLoading = false
            var msg = error.response.data.message + ' (' + obj.product_no + ')'
            this.$swal('Error', msg, 'error')
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        console.log('resp.data')
        console.log(resp.data)
        var respProduct = null
        for (let a = 0; a < resp.data.length; a++) {
          respProduct = respProduct == null ? resp.data[a].product_no + ', ' : respProduct + resp.data[a].product_no
        }
        var respMessage = resp.message + ' (' + resp.data.length + ') product' + '<br>' + '<pre>' + respProduct + '</pre>'
        this.$swal('Success', respMessage, 'success')
      }
    },
    async setQtyTotal (code) {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = auth.user.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setTotal () {
      var array = this.selected
      this.$Progress.start()
      this.loader.isLoading = true
      for (let i = 0; i < array.length; i++) {
        var data = this.dataRaw.find(d => d.id === array[i])
        await this.setQtyTotal(data.product_no)
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    exportExcel () {
      var data = {
        format: 'excel',
        product: this.dataRaw
      }
      console.log(product2Url + '/export-summary-cost-excel')
      console.log(data)
      axios.post(product2Url + '/export-summary-cost-excel', data, { responseType: 'blob' })
        .then(response => {
          console.log(response)
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'product-cost-summary.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshProduct () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      console.log(begin + ' ' + end)
      console.log(productUrl + '/summary-cost?end=' + end + '&warehouse=' + this.warehouse)
      await axios.get(productUrl + '/summary-cost?end=' + end + '&warehouse=' + this.warehouse, { headers: getHeader(), timeout: 600000 })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.refreshJournal()
    },
    async refreshJournal () {
      if (this.authUser.permissions.product_summary_cost_view_cost) {
        const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
        const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
        var array = this.dataRaw
        for (let i = 0; i < array.length; i++) {
          var amountLength = array[i].amount.length
          if (amountLength > 0) {
            var obj = {
              account: array[i].account_code,
              begin: begin,
              end: end,
              product_no: array[i].product_no
            }
            console.log(obj)
            await axios.post(financeUrl + '/buku-besar-persediaan', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.$set(array[i], 'total_journal', response.data.saldoAkhirRaw)
                var totalDiff = parseFloat(array[i].total) - parseFloat(array[i].total_journal)
                this.$set(array[i], 'total_diff', Math.abs(totalDiff))
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          } else {
            this.$set(array[i], 'total_journal', 0)
          }
        }
      }
    },
    async getBukuBesar () {
      var array = this.dataRaw
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: array[i].account_code,
          begin: begin,
          end: end,
          product_no: array[i].product_no
        }
        await axios.post(financeUrl + '/buku-besar-persediaan', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            array[i].total_journal = response.data.saldoAkhirRaw
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    }
  }
}
</script>

<style>
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
